import {
  UPDATEWALLETTRANSACTIONSTATUSADMIN_SUCCESS,
  UPDATEWALLETTRANSACTIONSTATUSADMIN_FAILED,
  RESET_UPDATEWALLETTRANSACTIONSTATUSADMIN,
  LOADING_UPDATEWALLETTRANSACTIONSTATUSADMIN,
  NETWORK_ERROR_UPDATEWALLETTRANSACTIONSTATUSADMIN,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_UPDATEWALLETTRANSACTIONSTATUSADMIN:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case UPDATEWALLETTRANSACTIONSTATUSADMIN_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case UPDATEWALLETTRANSACTIONSTATUSADMIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_UPDATEWALLETTRANSACTIONSTATUSADMIN:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_UPDATEWALLETTRANSACTIONSTATUSADMIN:
      return (state = initialState);
    default:
      return state;
  }
};
